const authToken = () => document.querySelector('[name=csrf-token]').content;

const post = (url, body) => new Promise((resolve, reject) => {
  fetch(url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-XSRF-TOKEN': authToken()
    },
    body: JSON.stringify(body)
  }).then(res => {
    if (res.ok) {
      return resolve(res.json());
    }
    throw new Error('Something went wrong', { cause: res });
  }).catch(error => {
    error.cause.json().then(res => {
      reject({data: res});
    })
  })
})

const parseErrors = response => {
  const { errors } = response.data;
  if (!errors) return response.data;
  if (typeof errors === 'string') return { errors };
  return Object.entries(errors).reduce((_errors, [key, values]) => {
    _errors[key] = Array.isArray(values) ? values.join(' and ') : values;
    return _errors;
  }, {});
};

const promisify = promise => {
  return new Promise((resolve, reject) => {
    promise
      .then(resolve)
      .catch(res => reject(parseErrors(res)));
  });
}

export const enroll = async (token, {email, newsletter}) => await promisify(
  post('/api/users/enroll', {token, email, newsletter})
)

// export const createSubscription = async (token, payload) => await promisify(
//   post('/api/users/current/subscribe', {token, ...payload})
// )

export const switchSubscription = async payload => await promisify(
  post('/api/users/current/switch_subscription', payload)
)

export const createUserAndSubscription = async (token, payload) => await promisify(
  post('/api/users/create_with_subscription', {token, ...payload})
)

export const completeRegistration = async payload => await promisify(
  post('/api/users/complete_registration', payload)
)

export const requestExtraSearches = async (token, email) => await promisify(
  post('/api/users/request_extra_searches', { token, user: { email } })
)

export const track = async (eventName, eventProperties = {}) =>
  post('/api/users/current/track', { event_name: eventName, event_properties: eventProperties })
